import { Grid } from '@material-ui/core';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { IMovieListItem } from '../../../services/supportMovie/supportMovie.types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { useState } from 'react';
import { useStyles } from './MovieDetails.styles';
import { updateMovieLike } from '../../../services/supportMovie/supportMovie.service';
import { Link } from 'react-router-dom';
import { Paths } from '../../../utils/routerUrls';
import { MovieIframe } from '../MovieIframe/MovieIframe.component';
import { useLayoutContext } from '../../../Context/Layout.context';

interface MovieDetailsProps {
  movieProps: IMovieListItem;
  deleteFunc: () => void;
  updateFunc: () => void;
  isAdminPermission: boolean;
}

export const MovieDetails: React.FC<MovieDetailsProps> = ({
  movieProps,
  deleteFunc,
  updateFunc,
  isAdminPermission,
}) => {
  const [like, setLike] = useState<boolean>(movieProps.isLiked);
  const classes = useStyles();
  const { openAlert } = useLayoutContext();

  const handleLike = (currLike: boolean) => {
    updateMovieLike(movieProps.id).then(
      (response) => {
        if (response.statusText == 'OK') {
          setLike(currLike);
        } else {
          () => {
            openAlert('error', `Nie udało się załadować pliku`);
          };
        }
      },
      () => openAlert('error', `Nie udało się załadować pliku`),
    );
  };

  const likeStyle = like ? classes.likeBlue : classes.likeBlack;

  const movieStyleProps = { width: '100%', height: '180px', border: 'none' };

  return (
    <Grid item xs={12} md={3}>
      <Card>
        <MovieIframe movieUrl={movieProps.url} movieStyle={movieStyleProps}></MovieIframe>
        <Link className={classes.detailsLink} to={`${Paths.supportMoviesWatch}/${movieProps.id}`}>
          <CardContent>
            <div className={classes.detailsTitleContainer}>
              <Typography gutterBottom variant="h6" component="div">
                {movieProps.title}
              </Typography>
            </div>
            <div className={classes.detailsDescriptionContainer}>
              <Typography variant="body2" color="text.secondary">
                {movieProps.description}
              </Typography>
            </div>
          </CardContent>
        </Link>
        {isAdminPermission && (
          <CardActions className={classes.detailsCardActionContainer}>
            <span>
              <ThumbUpOutlinedIcon className={likeStyle} onClick={() => handleLike(!like)}></ThumbUpOutlinedIcon>
            </span>
            <span className={classes.detailsCardActionEditDeleteIcon} onClick={updateFunc}>
              <EditOutlinedIcon></EditOutlinedIcon>
            </span>
            <span className={classes.detailsCardActionEditDeleteIcon} onClick={deleteFunc}>
              <DeleteOutlineIcon></DeleteOutlineIcon>
            </span>
          </CardActions>
        )}
      </Card>
    </Grid>
  );
};
